import { isOneOf } from '../../helpers/is-one-of.js'

export const LOAN_ISSUE_GROUPS = [
  'PROGRAM',
  'CONSISTENCY',
  'COMPLETENESS',
  'RESERVES',
  'DISCLOSURE',
] as const
export type LoanIssueGroup = (typeof LOAN_ISSUE_GROUPS)[number]

export const LOAN_ISSUE_GROUP_LABELS: Record<LoanIssueGroup, string> = {
  PROGRAM: 'Program',
  CONSISTENCY: 'Consistency',
  COMPLETENESS: 'Completeness',
  RESERVES: 'Reserves',
  DISCLOSURE: 'Disclosure timing',
}

export function isLoanIssueGroup(value: string): value is LoanIssueGroup {
  return isOneOf(value, LOAN_ISSUE_GROUPS)
}
